module.exports = __webpack_public_path__ + "img/blog_13.7362988a.jpg";